import { useSelector } from "react-redux";

const flatteningPages = (pages) => {
  const pgs = [];
  for (let i = 0; i < pages.length; i++) {
    if (!pages[i]?.is_hidden) {
      pgs.push({ ...pages[i], children: [] });
      if (pages[i].children) {
        pgs.push(...flatteningPages(pages[i].children));
      }
    }
  }
  return pgs;
};

export const defaultUrls = [
  // "",
  // "import",
  // "diagram_db",
  "sitemap",
  "version",
  "history",
];

function normalizeUrl(url) {
  switch (url) {
    case "privileges":
      return "privilegegroup";
    case "users":
      return "accounts";
    case "":
      return "import";
    default:
      return url;
  }
}

function findPageIdByPrivilege(pages, ct) {
  const newPages = flatteningPages(pages);
  for (const page of newPages) {
    const cpn = page?.component?.[0];
    if (cpn && ct.some((c) => c.cpn_id === cpn.id && c.read)) {
      return page.page_id;
    }
  }
  return "";
}

function hasReadByComponent(componentList, ct) {
  return componentList.some((cpn) =>
    ct.some((t) => t?.cpn_id === cpn?.id && t?.read)
  );
}

export default function useCheckPrivilege(item) {
  const { auth, pages } = useSelector((state) => state);
  const { role, ct = [] } = auth || {};
  const rawUrl = window.location.pathname.split("/")?.[1] || "";
  const url = normalizeUrl(item || rawUrl);
  const page_id = findPageIdByPrivilege(pages, ct);
  const token = localStorage.getItem("_token");

  if (
    ["pm", "uad"].includes(role) ||
    defaultUrls.includes(url) ||
    (token && item?.is_hidden) ||
    url === "user"
  ) {
    return { state: true };
  }

  if (!["pm", "uad"].includes(role) && url === "import") {
    return { state: false, page_id };
  }

  if (url === "privilegegroup" || url === "accounts") {
    const matched = ct.find(({ table_alias }) =>
      table_alias?.includes(url)
    )?.read;
    return { state: matched, page_id };
  }

  if (item?.component?.length) {
    const hasRead = hasReadByComponent(item.component, ct);

    return { state: hasRead, page_id };
  } else {
    return { state: false, page_id };
  }
}
